import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import * as React from "react";
import { Provider } from "react-redux";

//pages
import App from "./App";
import { NotificationProvider } from "createContextStore/NotificationContext";
import Store from "Store/index";

//css
import "./index.css";
import ErrorBoundary from "components/ErrorBoundary";

// Components
const Security = React.lazy(() => import("./Security.jsx"));

let Devtools = () => null;
if (process.env.NODE_ENV !== "production") {
  const { ReactQueryDevtools } = require("@tanstack/react-query-devtools");
  Devtools = () => <ReactQueryDevtools initialIsOpen={false} />;
}
const deepsinhSolanki = ReactDOM.createRoot(
  document.getElementById("deepsinhSolanki")
);

deepsinhSolanki.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={Store}>
        <NotificationProvider>
          <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
            <React.Suspense
              fallback={<div>Loading security features...</div>}
            >
              {process.env.NODE_ENV === "production" ?
                ["sagar@factbyte.com", "rushi@factbyte.com"].includes(JSON.parse(localStorage.getItem("userdata"))?.email) ? null : <Security /> : null}
            </React.Suspense>
            <App />
          </BrowserRouter>
        </NotificationProvider>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode >
);

// ✅ Disable console logs in production
if (process.env.NODE_ENV === "production") {
  console.log = console.debug = console.info = console.table = () => { };
}

